export const iconFontAwesomeSocialSquarePollVertical = (
	<i className="fa-solid fa-square-poll-vertical"></i>
);
